/* IMENHOF BLOOM — cart-undo.js
   In-place "Ongedaan maken" na verwijderen. De verwijderde regel verandert
   op zijn eigen plek in een herstel-strook met aflopende voortgangsbalk.
   - window.ImhUndo.mountRow(slot, opts): gedeeld door winkelwagenpagina + drawer.
   - Drawer-undo: neemt het verwijderen zelf over (capture-fase) zodat theme.js
     de body niet opnieuw opbouwt en de strook op zijn plek blijft staan.
   Het item wordt direct echt verwijderd zodat afrekenen altijd klopt; bij
   "Ongedaan maken" wordt het opnieuw toegevoegd. */
(function () {
  'use strict';
  var WINDOW = 8000;

  function undoIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7v6h6"/><path d="M3.5 13a9 9 0 1 0 2.2-6.4L3 9"/></svg>';
  }

  /* Vervangt de inhoud van een slot (een cart-line) door de herstel-strook.
     opts: { title, windowMs, onUndo, onExpire } */
  function mountRow(slot, opts) {
    opts = opts || {};
    var winMs = opts.windowMs || WINDOW;
    var prevHTML = slot.innerHTML;
    var prevClass = slot.className;
    slot.setAttribute('data-undo-pending', '1');
    slot.className = 'cart-undo-row';
    slot.innerHTML =
      '<span class="cart-undo-row__icon">' + undoIcon() + '</span>' +
      '<div class="cart-undo-row__text"><b>' + (opts.title || 'Product') + '</b> verwijderd' +
      '<span>Bedacht je je? Zet het terug.</span></div>' +
      '<button type="button" class="cart-undo-row__btn">Ongedaan maken</button>' +
      '<span class="cart-undo-row__bar"><i></i></span>';
    var bar = slot.querySelector('.cart-undo-row__bar i');
    bar.style.transitionDuration = winMs + 'ms';
    void bar.offsetWidth;
    requestAnimationFrame(function () { slot.classList.add('is-counting'); });

    var done = false;
    var timer = setTimeout(expire, winMs);

    function restore() {
      slot.className = prevClass;
      slot.innerHTML = prevHTML;
      slot.removeAttribute('data-undo-pending');
    }
    function undo() {
      if (done) return; done = true;
      clearTimeout(timer);
      if (opts.onUndo) opts.onUndo(restore);
    }
    function expire() {
      if (done) return; done = true;
      clearTimeout(timer);
      slot.classList.add('is-leaving');
      setTimeout(function () { if (opts.onExpire) opts.onExpire(slot); }, 300);
    }
    slot.querySelector('.cart-undo-row__btn').addEventListener('click', undo);
    return { undo: undo, expire: expire };
  }

  window.ImhUndo = { mountRow: mountRow, WINDOW: WINDOW };

  /* ---------- Drawer ---------- */
  var drawer = document.getElementById('CartDrawer');

  function money(c) {
    return (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat)
      ? Shopify.formatMoney(c, window.themeMoneyFormat)
      : '\u20ac' + (c / 100).toFixed(2).replace('.', ',');
  }

  function syncDrawer(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    var foot = document.getElementById('CartDrawerFoot');
    if (foot) {
      var t = foot.querySelector('[data-cart-total]');
      if (t) t.textContent = money(cart.total_price);
    }
    var body = document.getElementById('CartDrawerBody');
    if (!body) return;
    var threshold = parseInt(body.dataset.freeShip || 0, 10);
    var localThreshold = parseInt(body.dataset.localThreshold || 0, 10);
    var localRadius = parseInt(body.dataset.localRadius || 10, 10);
    var prog = body.querySelector('.cart-progress');
    if (prog && threshold > 0) {
      var localPending = localThreshold > 0 && cart.total_price < localThreshold;
      var target = localPending ? localThreshold : threshold;
      var pct = Math.min(100, (cart.total_price / target) * 100);
      var remain = threshold - cart.total_price;
      var localRemain = localThreshold - cart.total_price;
      var fill = prog.querySelector('.cart-progress__fill');
      if (fill) fill.style.width = pct + '%';
      var p = prog.querySelector('p');
      if (p) {
        if (localPending) {
        p.textContent = 'Nog ' + money(localRemain) + ' tot lokale bezorging binnen ' + localRadius + ' km \ud83c\udf3f';
        } else if (remain > 0) {
          p.textContent = 'Lokale bezorging binnen ' + localRadius + ' km is beschikbaar. Nog ' + money(remain) + ' tot bezorging buiten ' + localRadius + ' km \ud83c\udf3f';
        } else {
          p.textContent = 'Je komt in aanmerking voor bezorging aan huis \ud83c\udf3f';
        }
      }
    }
  }

  function drawerEmpty() {
    var foot = document.getElementById('CartDrawerFoot');
    if (foot) foot.hidden = true;
    var body = document.getElementById('CartDrawerBody');
    if (body) body.innerHTML = '<div class="cart-empty"><div class="cart-empty__icon">\ud83e\udeb4</div><h3>Je winkelwagen is leeg</h3><p>Ontdek onze planten en voeg je favorieten toe.</p><a class="btn" href="/collections/all" data-drawer-close>Bekijk planten</a></div>';
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var line = e.target.closest('.cart-line');
      if (!line || !line.dataset.key) return;
      var qtyEl = line.querySelector('[data-cart-qty]');
      var curQty = qtyEl ? (parseInt(qtyEl.value, 10) || 0) : 0;
      var isRemove = !!e.target.closest('.cart-line__remove');
      var isMinusToZero = !!e.target.closest('[data-cart-minus]') && curQty <= 1;
      // Alleen overnemen wanneer dit de regel verwijdert (Verwijderen, of - naar 0).
      if (!isRemove && !isMinusToZero) return;
      // Neem het verwijderen over zodat theme.js de body niet herbouwt.
      e.preventDefault();
      e.stopImmediatePropagation();

      var key = line.dataset.key;
      var titleEl = line.querySelector('.cart-line__title');
      var snap = {
        id: key.split(':')[0],
        quantity: curQty || 1,
        title: titleEl ? titleEl.textContent.trim() : 'Product'
      };

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        syncDrawer(cart);
        mountRow(line, {
          title: snap.title,
          onUndo: function (restore) {
            restore();
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: snap.id, quantity: snap.quantity })
            }).then(function () { return fetch('/cart.js'); })
              .then(function (r) { return r.json(); }).then(function (cart) {
                var it = cart.items.filter(function (i) { return String(i.variant_id) === String(snap.id); })[0];
                if (it) line.dataset.key = it.key;
                syncDrawer(cart);
              }).catch(function () { window.location.reload(); });
          },
          onExpire: function (slot) {
            slot.remove();
            var body = document.getElementById('CartDrawerBody');
            if (body && !body.querySelector('.cart-line, .cart-undo-row')) drawerEmpty();
          }
        });
      }).catch(function () { window.location.reload(); });
    }, true);
  }

  /* ---------- Bezorgmoment inklapbaar (drawer + winkelwagenpagina) ---------- */
  function enhanceBezorg() {
    var boxes = document.querySelectorAll('[data-imh-bezorgweek]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box._imhCollapse) return;
      box._imhCollapse = true;
      box.classList.add('js-collapsible');
      var head = box.querySelector('[data-imh-bw-toggle]');
      var summary = box.querySelector('[data-imh-bw-summary]');
      var status = box.querySelector('[data-imh-bw-status]');
      var inDrawer = !!box.closest('#CartDrawer');
      function setOpen(open) {
        box.classList.toggle('is-open', open);
        if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      setOpen(!inDrawer);
      if (head) head.addEventListener('click', function () {
        setOpen(!box.classList.contains('is-open'));
      });
      function mirror() {
        if (!summary || !status) return;
        var t = (status.textContent || '').replace(/^\s*Gekozen:\s*/i, '').trim();
        if (!t) return;
        summary.textContent = t.charAt(0).toUpperCase() + t.slice(1);
      }
      mirror();
      if (status && 'MutationObserver' in window) {
        new MutationObserver(mirror).observe(status, { childList: true, characterData: true, subtree: true });
      }
    });
  }
  enhanceBezorg();
})();
